'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _WidgetWrapper = require('../WidgetWrapper');

var _WidgetWrapper2 = _interopRequireDefault(_WidgetWrapper);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var RequestStatusTypes = _interopRequireWildcard(_RequestStatusTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizes = {
  small: 'small',
  'extra-small': 'extra-small',
  default: 'default'
};

var VisitorWidget = function (_React$Component) {
  _inherits(VisitorWidget, _React$Component);

  function VisitorWidget(props) {
    _classCallCheck(this, VisitorWidget);

    var _this = _possibleConstructorReturn(this, (VisitorWidget.__proto__ || Object.getPrototypeOf(VisitorWidget)).call(this, props));

    _this.isReady = _this.isReady.bind(_this);
    _this.closeWidget = _this.closeWidget.bind(_this);
    return _this;
  }

  _createClass(VisitorWidget, [{
    key: 'isReady',
    value: function isReady() {
      var widgetDataStatus = this.props.widgetDataStatus;


      var hasWidgetData = widgetDataStatus === RequestStatusTypes.SUCCEEDED;

      return hasWidgetData;
    }
  }, {
    key: 'closeWidget',
    value: function closeWidget() {
      this.props.onUpdateOpened(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          browserWindowHeight = _props.browserWindowHeight,
          chatHeadingConfig = _props.chatHeadingConfig,
          currentConversation = _props.currentConversation,
          chatHeadingResponders = _props.chatHeadingResponders,
          coloring = _props.coloring,
          inline = _props.inline,
          isPreview = _props.isPreview,
          isOpen = _props.isOpen,
          isThreadAssigned = _props.isThreadAssigned,
          createNewThread = _props.createNewThread,
          mobile = _props.mobile,
          officeHoursMessage = _props.officeHoursMessage,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          showThreadList = _props.showThreadList,
          showThreadListButton = _props.showThreadListButton,
          size = _props.size,
          style = _props.style,
          typicalResponseTimeMessage = _props.typicalResponseTimeMessage,
          unseenThreadsCountExcludingCurrentThread = _props.unseenThreadsCountExcludingCurrentThread,
          viewingThreadList = _props.viewingThreadList;


      if (!this.isReady() || !isOpen) {
        return null;
      }

      var className = (0, _classNames2.default)('widget-manager', {
        small: size === sizes.small,
        'extra-small': size === sizes['extra-small']
      });
      return _react2.default.createElement(
        'div',
        { className: className, style: style },
        _react2.default.createElement(
          'div',
          { className: 'widget-manager-content' },
          _react2.default.createElement(
            'div',
            { className: 'p-top-6' },
            _react2.default.createElement(
              _WidgetWrapper2.default,
              {
                browserWindowHeight: browserWindowHeight,
                chatHeadingConfig: chatHeadingConfig,
                coloring: coloring,
                createNewThread: createNewThread,
                currentConversation: currentConversation,
                chatHeadingResponders: chatHeadingResponders,
                inline: inline,
                isThreadAssigned: isThreadAssigned,
                mobile: mobile,
                officeHoursMessage: officeHoursMessage,
                onClose: this.closeWidget,
                preview: isPreview,
                showAvailabilityMessage: showAvailabilityMessage,
                showThreadList: showThreadList,
                showThreadListButton: showThreadListButton,
                typicalResponseTimeMessage: typicalResponseTimeMessage,
                unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
                viewingThreadList: viewingThreadList
              },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return VisitorWidget;
}(_react2.default.Component);

VisitorWidget.propTypes = {
  browserWindowHeight: _react.PropTypes.number.isRequired,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List),
  children: _react.PropTypes.node.isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  createNewThread: _react.PropTypes.func,
  currentConversation: (0, _RecordPropType2.default)('Conversation'),
  inline: _react.PropTypes.bool.isRequired,
  isOpen: _react.PropTypes.bool.isRequired,
  isPreview: _react.PropTypes.bool.isRequired,
  isThreadAssigned: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool.isRequired,
  officeHoursMessage: _react.PropTypes.string,
  onUpdateOpened: _react.PropTypes.func,
  showAvailabilityMessage: _react.PropTypes.bool,
  showThreadList: _react.PropTypes.func,
  showThreadListButton: _react.PropTypes.bool.isRequired,
  size: _react.PropTypes.oneOf(Object.keys(sizes)).isRequired,
  style: _react.PropTypes.object,
  typicalResponseTimeMessage: _react.PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number,
  viewingThreadList: _react.PropTypes.bool,
  widgetDataStatus: _react.PropTypes.oneOf(Object.keys(RequestStatusTypes)).isRequired
};

VisitorWidget.defaultProps = {
  inline: false,
  isOpen: false,
  isPreview: false,
  isThreadAssigned: false,
  mobile: false,
  onUpdateOpened: function onUpdateOpened() {},
  size: sizes.default
};

exports.default = VisitorWidget;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/components/VisitorWidget.js
// module id = 1041
// module chunks = 2 3